import { mapState } from "vuex";
import { MessageBox } from "element-ui";

export default {
  computed: {
    ...mapState({
      prem: (state) => state.user.prem,
    }),
    isHasPrem() {
      let has = false;
      //console.log(this.productId);
      this.productId.forEach((id) => {
        has = this.prem.findIndex((item) => item == id) > -1;
        if (has) {
          return true;
        }
      });
      return has;
    },
  },
  methods: {
    hasPrem() {
      //console.log(this.isHasPrem);
      if (!this.isHasPrem) {
        MessageBox.alert(
          "您未订购该产品，请联系国研网采购部门或致电400-7070-678。",
          "提示",
          {
            confirmButtonText: "确定",
            callback: (action) => {},
          }
        );
      }
      return this.isHasPrem;
    },
  },
};
